export default __webpack_public_path__ + "static/media/logo.52bd28b7.png";